.deleteWrapper {
	padding-top: 8px;
}